__turbopack_context__.v({
  "container": "AuthorContent-module-scss-module__2FAJ6W__container",
});
